// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__17ruv","col":"styles_col__3aor5"};